module.exports = __webpack_public_path__ + "img/lance.bc858e0b.jpg";